// Youssef Selkani
// 2019

import React, { Component } from 'react'
import '../App.css'
import {
  Form,
  Input,
  Radio,
  TextArea,
  Label,
  Button,
  Icon,
  Loader,
  Dropdown,
  Checkbox,
  Grid,
  Segment,
  Progress,
  Message
} from 'semantic-ui-react'
import { InputFile } from 'semantic-ui-react-input-file'

export default class MakerInputs extends Component {
  render () {
    let {
      compType,
      h1,
      h2,
      h3,
      urlBtn,
      navigBtn,
      fetching,
      screenBtnValue,
      screens,
      sheets,
      listValue,
      edit,
      empty,
      wordpressURL,
      storeurl,
      uploading,
      success,
      align,
      btnType,
      progress,
      responsive,
      chartType
    } = this.props
    return (
      <div className='mts' style={{ paddingLeft: 14, paddingRight: 14 }}>
        <h3>New {compType}</h3>
        <Form size='large' fluid>
          {compType === 'header' && (
            <div>
              <div className='mbs'>
                <Input
                  type='text'
                  placeholder='Lorem ipsum dolor'
                  fluid
                  onChange={this.props.handleChange}
                  name='compValue'
                />
              </div>
              <Label size='large'>Align</Label>
              <div className='mtbs'>
                <Grid columns='3' centered stackable>
                  <Grid.Column>
                    <div className='screen-card'>
                      <Checkbox
                        label='Left'
                        value='left'
                        checked={align === 'left'}
                        onChange={this.props.textAlign}
                      />
                    </div>
                  </Grid.Column>
                  <Grid.Column>
                    <div className='screen-card'>
                      <Checkbox
                        label='Center'
                        value='center'
                        checked={align === 'center'}
                        onChange={this.props.textAlign}
                      />
                    </div>
                  </Grid.Column>
                  <Grid.Column>
                    <div className='screen-card'>
                      <Checkbox
                        label='Right'
                        value='right'
                        checked={align === 'right'}
                        onChange={this.props.textAlign}
                      />
                    </div>
                  </Grid.Column>
                </Grid>
              </div>
              <Label size='large'>Format</Label>
              <div className='mb mts'>
                <Grid columns='3' centered stackable>
                  <Grid.Column>
                    <div className='screen-card'>
                      <Radio label='h1' toggle onChange={this.props.headerType1} checked={h1} />
                    </div>
                  </Grid.Column>
                  <Grid.Column>
                    <div className='screen-card'>
                      <Radio label='h2' toggle onChange={this.props.headerType2} checked={h2} />
                    </div>
                  </Grid.Column>
                  <Grid.Column>
                    <div className='screen-card'>
                      <Radio label='h3' toggle onChange={this.props.headerType3} checked={h3} />
                    </div>
                  </Grid.Column>
                </Grid>
              </div>
            </div>
          )}
          {compType === 'text' && (
            <div>
              <div className='mbs'>
                <TextArea
                  rows={6}
                  placeholder='Text content'
                  fluid
                  onChange={this.props.handleChange}
                  name='compValue'
                />
              </div>

              <Label size='large'>Align</Label>
              <div className='mts'>
                <Grid columns='3' centered stackable>
                  <Grid.Column>
                    <div className='screen-card'>
                      <Checkbox
                        label='Left'
                        value='left'
                        checked={align === 'left'}
                        onChange={this.props.textAlign}
                      />
                    </div>
                  </Grid.Column>
                  <Grid.Column>
                    <div className='screen-card'>
                      <Checkbox
                        label='Center'
                        value='center'
                        checked={align === 'center'}
                        onChange={this.props.textAlign}
                      />
                    </div>
                  </Grid.Column>
                  <Grid.Column>
                    <div className='screen-card'>
                      <Checkbox
                        label='Right'
                        value='right'
                        checked={align === 'right'}
                        onChange={this.props.textAlign}
                      />
                    </div>
                  </Grid.Column>
                </Grid>
              </div>
            </div>
          )}
          {compType === 'admob' && (
            <Input
              type='text'
              placeholder='AdMob Uit ID'
              fluid
              onChange={this.props.handleChange}
              name='compValue'
            />
          )}
          {compType === 'button' && (
            <div className='mbs'>
              <div className='mtbs'>
                <Label size='medium'>Type</Label>
              </div>
              <Grid columns='2' centered stackable>
                <Grid.Column>
                  <div className='screen-card'>
                    <Radio
                      label='Navigation'
                      toggle
                      onChange={this.props.navigBtnFunc}
                      checked={navigBtn}
                    />
                  </div>
                </Grid.Column>
                <Grid.Column>
                  <div className='screen-card'>
                    <Radio label='URL' toggle onChange={this.props.urlBtnFunc} checked={urlBtn} />
                  </div>
                </Grid.Column>
              </Grid>
              <Grid centered stackable verticalAlign='top'>
                <Grid.Column width='6'>
                  <div className='screen-card '>
                    <div className='mbs'>
                      <Label size='medium'>Style</Label>
                    </div>
                    <Checkbox
                      checked={btnType === 'filled'}
                      label='Filled'
                      onChange={() => this.props.btnTypeFunction('filled')}
                    />
                    <br />
                    <Checkbox
                      label='Outline'
                      checked={btnType === 'outline'}
                      onChange={() => this.props.btnTypeFunction('outline')}
                    />
                  </div>
                </Grid.Column>
                <Grid.Column width='10'>
                  <div className='screen-card'>
                    <div className='mbs'>
                      <Label size='medium'>Button label</Label>
                    </div>
                    <Input
                      type='text'
                      placeholder='Label'
                      fluid
                      onChange={this.props.handleChange}
                      name='compValue'
                    />
                  </div>
                </Grid.Column>
              </Grid>
              <br />
              {urlBtn && (
                <div className='mts'>
                  <Input
                    type='text'
                    placeholder='URL link'
                    fluid
                    onChange={this.props.handleChange}
                    name='urlBtnValue'
                  />
                </div>
              )}

              {fetching && (
                <div className='mtbs'>
                  <Loader size='small' inline active />
                </div>
              )}

              {navigBtn && (
                <div className='mts'>
                  <Dropdown
                    text='Select screen'
                    upward={false}
                    value={screenBtnValue}
                    onChange={this.props.screenBtnValueFunc}
                    options={screens}
                  />

                  {screenBtnValue && (
                    <div className='mts'>
                      <Label size='small' color='green'>
                        Linked successfully
                      </Label>
                      <h6>Screen ID: {screenBtnValue}</h6>
                    </div>
                  )}
                </div>
              )}
              <h4>
                To change theme colors please visit <a href='/app/style'>this</a> page.
              </h4>
            </div>
          )}
          {compType === 'list' && (
            <div className='mts'>
              {empty ? (
                <div>
                  <h5>
                    No sheets found on this account. <a href='/sheets'>Create one</a>
                  </h5>
                </div>
              ) : (
                <Dropdown
                  text='Select sheet'
                  upward={false}
                  value={listValue}
                  onChange={this.props.listValueFunc}
                  options={sheets}
                />
              )}
              {fetching && (
                <div className='mtbs'>
                  <Loader size='mini' inline active />
                </div>
              )}
              {listValue && (
                <div className='mts'>
                  <Label size='small' color='green'>
                    Connected to: {listValue}
                  </Label>
                </div>
              )}
            </div>
          )}
          {compType === 'url' && (
            <Input
              type='text'
              placeholder='https://example.com'
              fluid
              onChange={this.props.handleChange}
              name='compValue'
            />
          )}
          {compType === 'webview' && (
            <div>
              <Input
                type='text'
                placeholder='Webview URL'
                fluid
                onChange={this.props.handleChange}
                name='compValue'
              />
              <div className='mts'>
                <Input
                  type='number'
                  labelPosition='right'
                  label='%'
                  placeholder='Height (required)'
                  fluid
                  onChange={this.props.handleChange}
                  name='webviewHeight'
                />
              </div>
            </div>
          )}
          {compType === 'image' && (
            <div>
              <h4>Remote</h4>
              <div className='mbs'>
                <Input
                  type='text'
                  placeholder='Image URL'
                  fluid
                  onChange={this.props.handleChange}
                  name='compValue'
                />
              </div>
              <div className='mbs'>
                <h4>Local</h4>
                <div className='mtbs'>
                  <InputFile
                    button='compact basic'
                    input={{
                      accept: 'image/x-png, image/jpeg',
                      id: 'input-control-id2',
                      onChange: this.props.handleUpload
                    }}
                  />
                </div>
                {uploading && (
                  <div className='mbs'>
                    <Progress fluid percent={progress} active color='blue' />
                    Uploading...
                  </div>
                )}
                {success && <Message compact>Uploaded successfully!</Message>}
                {responsive ? (
                  <div className='mtbs'>
                    <Button
                      fluid
                      onClick={this.props.responsiveImg}
                      content='Enable custom style'
                      style={{
                        backgroundColor: '#fff',
                        borderColor: '#f7d170',
                        borderStyle: 'solid',
                        borderWidth: '2px'
                      }}
                    />
                  </div>
                ) : (
                  <div className='mtbs'>
                    <Button
                      content='Responsive image'
                      fluid
                      onClick={this.props.cancelResponsive}
                      style={{
                        backgroundColor: '#fcfcfc',
                        borderColor: '#000',
                        borderStyle: 'solid',
                        borderWidth: '2px',
                        color: '#000'
                      }}
                    />
                  </div>
                )}
              </div>
              <Segment padded basic>
                <Grid columns='2' centered stackable>
                  <Grid.Column>
                    <Input
                      disabled={responsive}
                      type='text'
                      placeholder='Width'
                      fluid
                      onChange={this.props.handleChange}
                      name='imgWidth'
                    />
                  </Grid.Column>
                  <Grid.Column>
                    <Input
                      disabled={responsive}
                      type='text'
                      placeholder='Height'
                      fluid
                      onChange={this.props.handleChange}
                      name='imgHeight'
                    />
                  </Grid.Column>
                </Grid>
                <div className='mts'>
                  <h4>Align</h4>
                  <Grid columns='3' centered stackable>
                    <Grid.Column>
                      <div className='screen-card'>
                        <Checkbox
                          disabled={responsive}
                          label='Left'
                          value='left'
                          checked={align === 'left'}
                          onChange={this.props.textAlign}
                        />
                      </div>
                    </Grid.Column>
                    <Grid.Column>
                      <div className='screen-card'>
                        <Checkbox
                          disabled={responsive}
                          label='Center'
                          value='center'
                          checked={align === 'center'}
                          onChange={this.props.textAlign}
                        />
                      </div>
                    </Grid.Column>
                    <Grid.Column>
                      <div className='screen-card'>
                        <Checkbox
                          disabled={responsive}
                          label='Right'
                          value='right'
                          checked={align === 'right'}
                          onChange={this.props.textAlign}
                        />
                      </div>
                    </Grid.Column>
                  </Grid>
                </div>
              </Segment>
            </div>
          )}
          {compType === 'video' && (
            <div>
              <h4>Only YouTube videos are supported at this moment</h4>
              <div className='mbs'>
                <Input
                  type='text'
                  placeholder='Video URL'
                  fluid
                  onChange={this.props.handleChange}
                  name='compValue'
                />
              </div>
            </div>
          )}
          {compType === 'audio' && (
            <div className='mbs'>
              <h4>Enter MP3/WAV or SoundCloud URL</h4>

              <Input
                type='text'
                placeholder='Audio URL'
                fluid
                onChange={this.props.handleChange}
                name='compValue'
              />
            </div>
          )}
          {compType === 'phone' && (
            <Input
              type='number'
              placeholder='Phone number'
              fluid
              onChange={this.props.handleChange}
              name='compValue'
            />
          )}
          {compType === 'email' && (
            <Input
              type='email'
              placeholder='Email address'
              fluid
              onChange={this.props.handleChange}
              name='compValue'
            />
          )}
          {compType === 'address' && (
            <Input
              type='text'
              placeholder='Physical address'
              fluid
              onChange={this.props.handleChange}
              name='compValue'
            />
          )}
          {compType === 'map' && (
            <div>
              <Input
                type='number'
                placeholder='Latitude'
                fluid
                onChange={this.props.handleChange}
                name='latitude'
              />
              <div className='mts'>
                <Input
                  type='number'
                  placeholder='Longitude'
                  fluid
                  onChange={this.props.handleChange}
                  name='longitude'
                />
              </div>
            </div>
          )}
          {compType === 'wordpress' && (
            <div>
              {!wordpressURL ? (
                <p>
                  No website linked to this account. Visit{' '}
                  <a href='/manage/wordpress'>WordPress Manager</a> to set up yours.
                </p>
              ) : (
                <div>
                  <p>{wordpressURL}</p>
                  <Radio
                    label='Enable'
                    toggle
                    onChange={this.props.enableWpFunc}
                    disabled={!wordpressURL}
                  />
                </div>
              )}
            </div>
          )}
          {compType === 'woocommerce' && (
            <div>
              {!storeurl ? (
                <p>
                  No WooCommerce Store linked to this <a href='/manage/woocommerce'>account</a>
                </p>
              ) : (
                <div>
                  <p>{storeurl}</p>
                  <Radio
                    label='Enable'
                    toggle
                    onChange={this.props.enableWooFunc}
                    disabled={!storeurl}
                  />
                </div>
              )}
            </div>
          )}
          {compType === 'rss' && (
            <div>
            <Input
              type='text'
              placeholder='RSS Feed URL'
              fluid
              onChange={this.props.handleChange}
              name='compValue'
            />
            </div>
          )}
          {compType === 'chart' && (
            <div>
              <p>To display a chart you must have a public API</p>
              <h5>
                If the array is nested on a sub-directory please include the path e.g.
                "folder.subdir.path" (Do not include "/") otherwise if the array is on root level
                leave destination input blank.
              </h5>
              <h5>Data keys are required.</h5>
              <div className='mt'>
                <Checkbox
                  label='Line'
                  checked={chartType === 'line'}
                  onChange={() => this.props.chartTypeFunction('line')}
                />
              </div>
              <div className='mts'>
                <Checkbox
                  checked={chartType === 'area'}
                  label='Area'
                  onChange={() => this.props.chartTypeFunction('area')}
                />
              </div>
              <div className='mts'>
                <Checkbox
                  label='Bars'
                  checked={chartType === 'bars'}
                  onChange={() => this.props.chartTypeFunction('bars')}
                />
              </div>
              <div className='mt'>
                <Input
                  type='text'
                  label='API endpoint'
                  fluid
                  onChange={this.props.handleChange}
                  name='compValue'
                />
                <div className='mts'>
                  <Input
                    type='text'
                    label='Data key'
                    fluid
                    onChange={this.props.handleChange}
                    name='dataKey'
                  />
                </div>
                {chartType === 'area' && (
                  <div className='mts'>
                    <Input
                      type='text'
                      label='X axis'
                      fluid
                      onChange={this.props.handleChange}
                      name='dataKey2'
                    />
                  </div>
                )}
                <div className='mts'>
                  <Input
                    type='text'
                    label='Nested array destination'
                    fluid
                    onChange={this.props.handleChange}
                    name='nestedSub'
                  />
                </div>
              </div>
              <h5>
                <Icon name='exclamation triangle' color='yellow' />
                Experimental component
              </h5>
            </div>
          )}
          <div className='mtbs'>
            <Form.Button
              fluid
              disabled={!edit}
              content='Submit'
              onClick={this.props.submitComp}
              style={{ backgroundColor: '#000', color: '#fff' }}
            />
          </div>
          <Button
            fluid
            size='mini'
            style={{ backgroundColor: 'transparent', color: 'red' }}
            onClick={this.props.cancel}>
            <Icon name='angle left' /> Go back
          </Button>
        </Form>
      </div>
    )
  }
}
